import Vue from 'vue'
import vuex from 'vuex'
import {selfCookie} from '@/js/public/common.js'
import md5 from 'js-md5'
Vue.use(vuex)
import service from "./../js/service.js";
let isclicktouzhu = false;
let storeObj = new vuex.Store({
	state: {
    // 虚拟币 --- start
    allCoinData:'',//虚拟币存放getAllCoin接口的所有值
    defaultCoinData:{name:'人民币',code:'RMB',id:1,balance:'...',unit:'元'},//默认选中的是第几条虚拟币信息
    // 虚拟币 --- end
		isLogin: localStorage.getItem('_status') || 'false',
		isIndex: localStorage.getItem('_isIndex') || 'true',
		contenStatus: {},
		allLotteryList: [],
		baseInfo: {}, // 账户余额等信息
		timeleft: 0,
		lottery: [], // 整个头彩列表
		kefuData: '',
		openNavFlag:true,
		lthighlimit: 0,
		promptList: [], // 整个公告列表
		notice: [], // 消息，上下级发送内容消息
		lotteryBalance: '0.00', // 余额
		blockedBalance: '0.00', // 冻结金额
		loginListInfo: [], // 登录日志
		bgColor: localStorage.getItem('bgColor') || 0, // 背景颜色的变化
		userTime: '', // 当前是下午 中午 或晚上
		userType: '', // 用户类型
		activityList: [],// 活动列表
		newPersonStep: -1, // 新手指引第几步
		thirdGameBalances: [], // 第三方游戏余额
		unreadMessageNum: 0, // 未读消息的数量
    websocket: null, // socket对象
    websocketStatus: true, // 这个是websocket的链接状态  是否是断开的 一开始设置成true是为了防止初始时重复判断
		lineSpeedArr: [], // 线路测试得到的
		showBrowersFlag: false, // 浏览器窗口是否显示
		bgStyleFlag: false, // 切换背景颜色是否显示
		showContactFlag: false, // 社交窗口是否显示
		messageNum: 0,// 页头消息数量
		promtTotalCount: 0, // 公告的总条数
		//  changeStatue: '',
		appconfig: {},   // 下载二维码 客服连接,线路
		showLine:false, // 显示首页测试线路
		isBind:{}, // 绑定信息
		bgImgIndex:0,

		// 投注页面相关-----start
		issue: '', //即将开奖的期数
		historyLotteryInfoFirst: null, //最近一期开奖的期数和开奖号码等数据
		biggerType: '', // 最大的彩种类型  sscs jd flb other elvenY dpc
		currentIssue: '', // 当前正在开奖的期数
		currentLottery: null, // 当前选中的彩种大类  包含中文名字  英文名字  id  三个属性  cqssc 重庆时时彩 11
		openTime: '00-00-00', // 开奖时间的倒计时
		openTimeS: 0, // 开奖时间的倒计时
		currentPlayInfo: null, // 当前玩法的信息，确定投注的时候  可以使用 shortname compress
		lotteryConfig: null,
		followNum: false, // 是否追号
		note: 0, // 投注的注数
		maxBouns: 0, // 点击投注时弹框的最高限额值
		chooseNumberData: [], // 选号数据
		number_tableData: [], // 添加的号码表格数据
		shortName: '', // 当前玩法的code，即缩写名字，在计算实际选号数据时 和chooseNumberData一起作为参数传入
		multiple: 1, // 选注栏里面的倍数
		mode: '元', // 元  角  分  厘
		total: 0, // 选注栏的总金额
		bonus: '', // 选注栏  --滑块的奖金
		percent: '0.0', // 选注栏  --滑块的返点
		lottery_method: null, // 如  当前玩法的说有配置数据  在选择号码的时候有很多用处  比如中文玩法名称  最高奖金
		initStatus: true, // 这个状态用来初始化选号区的数据，当我们点击投注或者预投注的时候   改变这个状态，在选号区监听，然后初始化
		initStatus_tableRecord: true, // 这个状态用来刷新订单记录组件的表格数据  监听其改变时的状态来刷新表格
		initStatus_recentGame: true, //  这个状态用来刷新最近游戏（我的喜爱） 当改变时，会初始化最近游戏 从而达到刷新倒计时的功能
		initStatus_Rank: true, // 控制出码联动的初始化状态  改变时刷新
		initStatus_history: true, // 控制历史数据的初始化
		stopOpenTime: null, //停止开奖时间
    streamCOdeIn: true, // strem 投注时判断开奖号码
		writeNumber_Menu: '', // 做号投注菜单名 --主页面的菜单应和做号投注里面的菜单保持一致
		writeNumber_Data: {label: ''}, // 做号投注的数据 --用于做号投注生成号码之后将生成的号码同步到主页面上
		// 公共模态框
		defaultModal: false, // 基础弹框
		openLotteryModal: false, // 开奖弹框  单独出来的弹框
		ssc_openLotteryAnimation: false, //时时彩专属开奖号码
		modal_bettingNow: false, // 投注模态框
		thridTransfer_Modal: false, // 第三方游戏转账
		isNewTask: true,  //  是否有新手任务
		newPersonModal: false,  // 新手任务弹框
		newPersonBonus: false,  // 新手任务领取奖金弹框
		taskActivity: {},  // 新手任务奖金
		sortNo: [],  // 新手任务顺序
		newTaskMoney: [], //  新手任务完成后领取到的奖金
		H5DefaultModal: false, // 基础H5弹框
		modal_orderDetail: false,// 订单详情弹框是否打开
		modal_chaseDetail: false,// 追号详情弹框是否打开
		jd_betting: false,// 经典投注弹框
		favoriteFlag: false,
		favoriteLottery: [],
		canBet:true,
		isLoading: false,
		canBetTimer:null,
		//------投注页面相关分割线  end-------
		noticeCount: 0,  // 未读消息数
		sdzFlag: localStorage.getItem('_sdzFlag') === 'true' ? true : false, // 是否开启杀对子
		showSdzBtn: false, // 是否显示杀对子按钮
		threeMoney:[],
	},
	getters: {
		allLotteryList(state) {
			let A = function (id) {
				id = `,${id},`
				let ltgroups = appConfig.ltgroups
				let jd = `,${ltgroups.jd.join(',')},`
				let sscs = `,${ltgroups.ssc.join(',')},`
				let flb = `,${ltgroups.flb.join(',')},`
				let other = `,${ltgroups.other.join(',')},`
				let kuai = `,${ltgroups.k3.join(',')},`
				let elvenY = `,${ltgroups['11y'].join(',')},`
				if (jd.indexOf(id) > -1) {
					return 'jd'
				} else if (sscs.indexOf(id) > -1) {
					return 'sscs'
				} else if (flb.indexOf(id) > -1) {
					return 'flb'
				} else if (kuai.indexOf(id) > -1) {
					return 'k3'
				} else if (other.indexOf(id) > -1) {
					return 'other'
				} else if (elvenY.indexOf(id) > -1) {
					return 'elvenY'
				} else {
					return 'dpc'
				}
			}
			let a = JSON.parse(JSON.stringify(state.allLotteryList))

			a.forEach(item => {
				item.type = A(item.id)
				item.url = `/lottery#${item.id}`
			})
			return a
		},
		notice(state) {
			let A = function (str) {
				let s = "";
				if (str.length == 0) return "";
				s = str.replace(/&amp;/g, "&");
				s = s.replace(/&lt;/g, "<");
				s = s.replace(/&gt;/g, ">");
				s = s.replace(/&nbsp;/g, " ");
				s = s.replace(/&#39;/g, "\'");
				s = s.replace(/&quot;/g, "\"");
				return s
			}
			let a = JSON.parse(JSON.stringify(state.notice))
			a.forEach(item => {
				item.content = A(item.content)
			})
			return a
		},
		// 后台未开启的彩种需要过滤掉
		favoriteLottery(state) {
			let a = []
			state.favoriteLottery.forEach(obj => {
				let middle = state.allLotteryList.find(item => obj.lotteryId === item.id)
				if (middle) {
					a.push(obj)
				}
			})
			return a
		},
		// 是否启用杀对子
		isOpensdz(state) {
			if (state.showSdzBtn && state.sdzFlag) {
				return true
			}
			return false
		}
	},
	mutations: {
    setStore(state, res){
      //虚拟币专用setStore
      state[res.key] = res.data;
    },
		// 绑定信息
		['SET_BIND_INFO'](state,data){
			state.isBind = data
		},
		// 显示首页测试线路
		['SET_TEST_LINE'](state,data){
			state.showLine = data
		},
		// 投注相关
		setData(state, data) {
			state[data.key] = data.value; // 写入投注的相关数据
		},
		// 表格添加一条数据
		addItem(state, data) {
			state.number_tableData.push(data)
		},
		// 表格中删除事件
		deleteItem(state, data) {
			state.number_tableData.splice(data, 1)
		},
		setLuzhu(state, data) {
			state.luzhu = data
		},
		// 初始化所以公告弹框的状态
		initModal(state, data) {
			state.defaultModal = false;
			state.openLotteryModal = false;
			state.ssc_openLotteryAnimation = false;
			state.modal_bettingNow = false;
			state.H5DefaultModal = false;
			state.newPersonModal = false;
			state.modal_orderDetail = false;
			state.modal_chaseDetail = false;
			state.newPersonBonus = false;
		},
		setBaseInfo(state, obj) {
			state.baseInfo = Object.assign({}, state.baseInfo, obj);
		},
		loginStatus(state, status) {
			localStorage.setItem('_status', status)
			state.isLogin = status
		},
		setSdzFlag(state) {
			state.sdzFlag = state.sdzFlag ? false : true
			localStorage.setItem('_sdzFlag', JSON.stringify(state.sdzFlag))
		},
//  ChangeStatue (state, data) {
//  	if (data.flag) {
//      state.changeStatue = data.data
//   }
//  },
		setTimeleft(state, lefts) {
			state.timeleft = lefts
		},
		setNoticeCount(state, noticeCount) {
			state.noticeCount = noticeCount
		},
		isIndexs(state, status) {
			localStorage.setItem('_isIndex', status)
			state.isIndex = status
		},
		userContenStatus(state, status) {
			state.contenStatus = status
		},
		changeCountDownTime(state) {
			state.timeleft--
		},
		initCountDownTime(state, time) {
			state.timeleft = time
		},
		setAllLotteryList(state, list) {
			state.allLotteryList = list
		},
		setLottery(state, data) {
			state.lottery = Object.prototype.toString.call(data) === '[object Array]' ? data : []
		},
		setPromptList(state, data) {
			state.promptList = Object.prototype.toString.call(data) === '[object Array]' ? data : []
		},
		setPromtTotalCount(state, data) {
			state.promtTotalCount = data
		},
		setNotice(state, data) {
			state.notice = Object.prototype.toString.call(data) === '[object Array]' ? data : []
		},
		setLotteryBalance(state, data) {
      state.lotteryBalance = data
		},
		setLoginListInfo(state, data) {
			state.loginListInfo = Object.prototype.toString.call(data) === '[object Array]' ? data : []
		},
		setBlockedBalance(state, data) {
			state.blockedBalance = data
		},
		setBgColor(state, data) {
			state.bgColor = data
		},
		setUserTime(state, data) {
			state.userTime = data
		},
		setUserType(state, data) {
			state.userType = data
		},
		setActivityList(state, data) {
			state.activityList = data
		},
		setNewPersonStep(state, data) {
			state.newPersonStep = data
		},
		setThirdGameBalances(state, data) {
			state.thirdGameBalances = data
		},
		setLineSpeedArr(state, data) {
			if (data.flag) {
				state.lineSpeedArr = data.data
			} else {
				state.lineSpeedArr = []
			}
		},
		setShowBrowersFlag(state, data) {
			state.showBrowersFlag = data
		},
		setBgStyleFlag(state, data) {
			state.bgStyleFlag = data
		},
		setShowContactFlag(state, data) {
			state.showContactFlag = data
		},
		setMessageNum(state, data) {
			state.messageNum = data
		},
		setFavoriteLottery(state, data) {
			state.favoriteLottery = data
		},
		setFavoriteFlag(state, data) {
			state.favoriteFlag = state.favoriteFlag ? false : true
		},
		setWinVoice(state) {
			let a = selfCookie('WIN-VOICE', 1)
			let b = !a || a === 'OFF' ? 'ON' : 'OFF'
			selfCookie('WIN-VOICE', 0, b)
			state.voiceFlag = b
		}
	},
	actions: {
    // 虚拟币 -- start
    setCoinData({commit,state}){
      this._vm.$http.get('/yx/vc/coin/getAllCoin?opType=2').then((obj)=>{
        let res = obj.body;
        if(!res.error){
          let data = res.data;
          this._vm.$http.get('/yx/u/api/loop').then((obj)=>{
            let loopRes = obj.body;
            if(!loopRes.error){
              let loopData = loopRes.data;
              data.forEach(function (v, i) {
                v.balance = loopData[v.code]
                v.unit = '分'
              });
              let rmb = {name:'人民币',code:'RMB',id:1,balance:loopData.lotteryBalance,unit:'元'};
              data.unshift(rmb);
              // 预防localStorage没有生成setItemCoin的情况下按刷新
              let coinObj = JSON.parse(localStorage.getItem('setItemCoin'));
              if(coinObj === null){
                localStorage.setItem('setItemCoin', JSON.stringify(rmb));
              }
              // 保存所有的币种信息
              commit('setData',{key:'allCoinData',value:data});
              if(state.defaultCoinData===''){
                //在手动刷新页面时，应该也是获取上一次切换币种后的余额信息
                let rmb = {name:'人民币',code:'RMB',id:1,balance:loopData.lotteryBalance,unit:'元'};
                // 设置默认的币种信息
                commit('setData',{key:'defaultCoinData',value:rmb});
              }
            }
          });
        }

      });
    },
    // 虚拟币 -- end
		//立即投注和确认投注的ajax事件
		ajaxBetting({commit, state}, context) {
			if(isclicktouzhu)return false;
			isclicktouzhu = true;

			let that = context.that;

			// console.log(state.streamCOdeIn, context)
			// if(context['arr'][0].lottery === 'ST300SSC' || context['arr'][0].lottery === 'ST60SSC'){
			// 	if(!state.streamCOdeIn){
			//
			// 		that.$Modal.al_default({status: 'warning', content: '!'});
			// 		state.canBet = true;
			// 		// 清空限制可以投注的定时器
			// 		clearTimeout(state.canBetTimer)
      //     state.canBetTimer = null
			// 		return false;
			// 	}
			// }

			let url = context.url;
			let arr = context.arr;
			!url && (url = 'game-lottery/add-order') //没有url的时候   就设置成立即投注的url   有的话就是追号的url
			//传过去的数据必须是数组的json格式

			service.post(that, url, {'text': JSON.stringify(arr)}).then(function (result) {
				isclicktouzhu = false;
				let res = result.data;
				let _thiss = this;
				if (res.code === 0||res.code === -1001) {
					// 提示投注成功
					// that.$Modal.al_default({status: 'success', content: '您的订单投注成功！'})
					App.alert('success', '提示消息','您的订单投注成功', 3000);
					// this.$Modal.al_openLottery({status: 'success', content: '您的订单投注成功!', time: 3000})
					// 发送成功之后，会得到用户的剩余金额  vuex修改一下
					state.baseInfo.lotteryBalance = res.data
					//然后刷新一下订单记录表格的数据
					state.initStatus_tableRecord = !state.initStatus_tableRecord
					//选号提交（投注  追号  添加号码等）之后，需要刷新选号区的数据
					/*
					 * 添加完数据之后，需要将选号区的数据清空
					 * 这个用vuex来做，给个状态，在选号区监听，当其状态改变的时候  就清空数据
					 */
					state.initStatus = !state.initStatus
					//清空已添加选号的表格
					state.number_tableData = [];
					// 重新可以投注
					state.canBet = true;
					// 清空限制可以投注的定时器
					clearTimeout(state.canBetTimer)
          state.canBetTimer = null
					if(res.message.indexOf('lotteryId') != -1){
						let msgData = JSON.parse(res.message);
						let modes = {
							'yuan':0,
							'jiao':1,
							'fen':2,
							'li':3
						}
						var unAnimatedSlider = document.getElementById('process_note');
						try{
							unAnimatedSlider.noUiSlider.set(msgData.code);
						}catch(err){
							console.log(err)
						}
						commit('setData',{key: 'multiple', value: msgData.multiple})
						// this.setData({key: 'multiple', value: 1})
						let mincodes = (state.baseInfo.lotteryAccount.point - ((msgData.code - (state.lotteryConfig.sysCode - state.baseInfo.lotteryAccount.point * 20)) / 20).toFixed(1)).toFixed(1)//初始化出占比
						// this.setData({key: "bonus", value: this.currentCode})
						// this.setData({key: "percent", value: this.percent})
						commit('setData',{key: "percent", value: mincodes})
						commit('setData',{key: 'bonus', value: msgData.code})
						// $('.lotteryContentBox .note .calc input').eq(0).val('24');
						$('#process_nspneLvy').attr('method', msgData.method);
						$('#process_nspneLvy').html(msgData.code+'/'+mincodes+'%');
						$('.lotteryContentBox .note .mode span').eq(modes[msgData.model]).trigger('click');
					 	setTimeout(function(){
							_thiss.$router.push('/lottery/#'+msgData.lotteryId);
						},1000)
					}
        } else if(res.code == '-1000' || res.code == -1000||res.code == '-2000' || res.code == -2000){

					// console.log('------',res)
					if(res.message >= 0 && res.message <= 30){
						state.isLoading = true;
						setTimeout(()=>{
							state.isLoading = false;
							state.canBet = true;
							// that.$Modal.al_default({status: 'warning', content: '网络链接超时!'})
						},res.message*1000)
					}else{
						return	App.alert('warning', '提示消息','网络链接超时', 3000);
						// that.$Modal.al_default({status: 'warning', content: '网络链接超时!'})
					}


				} else {
					App.alert('warning', '提示消息',res.message, 3000);
					// that.$Modal.al_default({status: 'warning', content: res.message})
				}


			}, function (err) {
				isclicktouzhu = false;
				console.log(err)
			})


		},
		getThreeMoney({commit,state},platformId){
			this._vm.$http.post('/yx/thirdGameApi/common/showThirdAmount?isForced=true&platformId='+platformId, {emulateJSON: true}).then(res => {
				let obj = res.body;
				if(platformId===5){
					//5--真人
					state.threeMoney.ag = obj.data;
				}
				if(platformId===10){
					//10--cq
					state.threeMoney.cq = obj.data;
				}
				if(platformId===22){
					//22--ds(gm)
					state.threeMoney.ds = obj.data;
				}
				if(platformId===6){
					//6--体育
					state.threeMoney.im = obj.data;
				}
				// if(platformId===24){
				// 	//6--体育
				// 	state.threeMoney.ds = obj.data;
				// }
				if(platformId===27){
					//6--体育
					state.threeMoney.pt = obj.data;
				}

				console.log(obj,state.threeMoney,9999999999)

			})
		},
		getAppconfig({commit}) {
			this._vm.$http.post('/yx/game-lottery/init-page', {}).then(res => {
				var rsult = res.body;
				if(rsult.code != 0) return false;
				if(rsult.data.main) {
					var nickname = rsult.data.main.username;
					this._vm.$http.get('/upload/json/app2.json', {}).then(res => {
						var b_data = res.body;
						var addonstr = '&info='+escape("userId="+md5(nickname)+"&name="+nickname);
						b_data.kefu = b_data.kefu + addonstr;
						console.log(b_data,'66666666666666666')
						b_data.urls = b_data.urls.split(',');
						appConfig.speedSrc = b_data.urls;
						document.title = b_data.name
						appConfig.title = b_data.name
						commit('setData', {key: 'appconfig', value: b_data})
						// document.body.getElementsByTagName('title')[0].innerHTML = res.body.name
					})
				}else{
					this._vm.$http.get('/upload/json/app2.json', {}).then(res => {
						var b_data = res.body;
						// console.log(7777777777,b_data)
						b_data.urls = b_data.urls.split(',');
						appConfig.speedSrc = b_data.urls
						document.title = b_data.name
						appConfig.title = b_data.name
						commit('setData', {key: 'appconfig', value: b_data})
						// document.body.getElementsByTagName('title')[0].innerHTML = res.body.name
					})
				}

				// document.body.getElementsByTagName('title')[0].innerHTML = res.body.name
			})

		},
		setFavoriteLottery({commit}) {
			console.log(222222)
			this._vm.$http.post('/yx/u/api/game-lottery/get-favourite-game', {}, {emulateJSON: true}).then(res => {
				if (res.body.code === 0) {
          res.body.data.map(item => item.surplusTime = Number(item.surplusTime))
					commit('setFavoriteLottery', res.body.data)
				}
			})
		}
	}
})

storeObj.commit('setWinVoice')
export default storeObj



// WEBPACK FOOTER //
// src/store/store.js